import './StateLabel-bc1aea93.css';

var classes = {"StateLabel":"prc-StateLabel-StateLabel-ukDwa","Icon":"prc-StateLabel-Icon-NuDm4"};

export { classes as default };
